import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { ClipLoader } from "react-spinners";
import {
  API_URL,
  baseChainId,
  baseChainParams,
  POOL_MANAGER_ADDRESS,
} from "./config/config.js";
import { metaMaskImage } from "./assets/metamask.js";
import { formatAddress, isValidEthereumAddress } from "./utils/utils.js";
import AlertModal from "./components/alertModal.js";
import "./App.css";
import { bitcoin, logo } from "./assets/images.js";
import TextInput from "./components/TextInput.js";
import VaultInput from "./components/VaultInput.js";
import { poolManager_abi } from "./abis/poolManager_abi.js";

function App() {
  const [message, setMessage] = useState("");
  const [deployedVault, setDeployedVault] = useState("");

  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [decimals, setDecimals]= useState(0)
  const [tokenAddress, setTokenAddress] = useState("");
  const [lockDuration, setLockDuration] = useState(0);
  const [walletAddress, setWalletAddress] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(false);
 
  const connectWallet = async () => {
    try {
      if (!window.ethereum) {
        setMessage(
          "MetaMask is not installed. Please install it to use this app."
        );
        return;
      }
      const chainId = await window.ethereum.request({ method: "eth_chainId" });
      if (chainId !== baseChainId) {
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: baseChainId }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            try {
              await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [baseChainParams],
              });
            } catch {
              setMessage("Failed to add Base network to MetaMask.");
              return;
            }
          } else {
            setMessage("Failed to switch to the Base network.");
            return;
          }
        }
      }

      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setWalletAddress(accounts[0]);
      setIsConnected(true);
    } catch {
      setMessage("Failed to connect to MetaMask.");
    }
  };

  const disconnectWallet = () => {
    setWalletAddress("");
    setIsConnected(false);
    setMessage("");
    localStorage.clear();
    sessionStorage.clear();
  };

  const deployTokenVault = async () => {
    setLoading(true);
    if (!walletAddress) {
      setMessage("Please connect your MetaMask wallet first.");
      setLoading(false);
      return;
    }

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    const poolManagerContract = new ethers.Contract(
      POOL_MANAGER_ADDRESS,
      poolManager_abi,
      signer
    );

    if (!name || !symbol) {
      setMessage("Please Input the Name and Symbol");
      setLoading(false);
      return;
    }

    if (decimals == 0) {
      setMessage("Please Input the decimals.");
      setLoading(false);
      return;
    }

    if (!isValidEthereumAddress(tokenAddress)) {
      setMessage("Token address is not a valid Ethereum address.");
      setLoading(false);
      return;
    }

    if (lockDuration == 0) {
      setMessage("Set the Lock Duration.");
      setLoading(false);
      return;
    }

    
    if (name && symbol && tokenAddress) {
      try {
        await poolManagerContract.deployVault(tokenAddress, name, symbol, decimals, lockDuration);
      } catch (error) {
        console.error("Error deploying vault:", error);
        setMessage("Failed to deploy vault. Please try again.");
        setLoading(false);
      } finally {
        setMessage("Successfully deployed vault.");
        setLoading(false);
      }
    }
  };

  return (
    <div className="App">
      <div className="NavBar">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={logo} width="30px" />
          <h2>COVAULT</h2>
        </div>
        <div className="WalletConnect">
          <button onClick={isConnected ? disconnectWallet : connectWallet}>
            <img src={metaMaskImage} alt="Metamask" />
            <div style={{ color: "white" }}>
              {isConnected ? formatAddress(walletAddress) : `Connect Wallet`}
            </div>
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2>🎇 Please Deploy Your ERC7540 Vaults. 🎇</h2>
        <div className="Card">
          <div
            className="Card-Header"
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              padding: "6px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={logo} width="20px" />
              <h3>COVAULT</h3>
            </div>
            <h3>Tokenized Yield Vault</h3>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
            }}
          >
            <TextInput
              text={name}
              setText={setName}
              title="Vault Name:"
              subtitle="Example Name"
              placeholder="Vault #001"
            />
            <TextInput
              text={symbol}
              setText={setSymbol}
              title="Symbol:"
              subtitle="Example Symbol"
              placeholder="$Y1LD"
            />
            <TextInput
              text={decimals}
              setText={setDecimals}
              title="Decimals:"
              subtitle="Example Decimals"
              placeholder="18"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "30px",
              width: "100%",
            }}
          >
            <VaultInput
              text={lockDuration}
              setText={setLockDuration}
              title="Time Locking Period"
              subtitle="Locking Period:"
              placeholder="100 days"
            />
            <VaultInput
              text={tokenAddress}
              setText={setTokenAddress}
              title="Deposit Token Address"
              subtitle="Enter Token Address:"
              placeholder="(0x...........)"
            />
          </div>
          <button
            onClick={deployTokenVault}
            style={{ width: "80%", backgroundColor: "#F6F951", color: "black" }}
          >
            {!loading ? (
              <p>Deploy Vault</p>
            ) : (
              <ClipLoader color={"#3498db"} size={35} />
            )}
          </button>
          <div style={{ paddingBottom: "30px" }}>
            By clicking "Confirm DEPLOY Vault", you agree to the Terms of
            Service and acknowledge that you have read and understand the
            compnay disclaimer. Learn more about the vault you're deploying
          </div>
        </div>
      </div>
      <AlertModal
        isOpen={deployedVault}
        onClose={() => setDeployedVault("")}
        message={`Your vault has been deployed to the address: ${deployedVault}`}
      />
      <AlertModal
        isOpen={message}
        onClose={() => setMessage("")}
        message={message}
      />
    </div>
  );
}

export default App;
